import { useSelector } from 'react-redux'

export const useCommonReducerSelector = () => {

    const commonReducerResponse = useSelector((state) => state.commonReducerForInitalData)
    const updateLabelToMarginResponse = commonReducerResponse.updateLabelToMargin
    const updateLabelPrintHeaderResponse = commonReducerResponse.updateLabelPrintHeader
    const updateLabelHeaderTopMarginResponse = commonReducerResponse.updateLabelHeaderTopMargin
    const updateLabelPrintTypeResponse = commonReducerResponse.updateLabelPrintType
    const updateLabelPrintLogoResponse = commonReducerResponse.updateLabelPrintLogo
    const updateLabelLeftMarginResponse = commonReducerResponse.updateLabelLeftMargin
    const updateLabelSigGapResponse = commonReducerResponse.updateLabelSigGap
    const pharmacyGetConsentEmailDataResponse = commonReducerResponse.pharmacyGetConsentEmailData
    const pharmacyAddConsentEmailDataResponse = commonReducerResponse.pharmacyAddConsentEmailData
    const pharmacyUpdateAuthenticationPhoneNumberResponse = commonReducerResponse.pharmacyUpdateAuthenticationPhoneNumber
    const pharmacyGetAuthenticationPhoneNumberResponse = commonReducerResponse.pharmacyGetAuthenticationPhoneNumber
    const getSearchHistoryResponse = commonReducerResponse.getSearchHistory
    const storeSearchHistoryResponse = commonReducerResponse.storeSearchHistory
    const witnessCarryResponse = commonReducerResponse.witnessCarry
    const bookkeeperModuleAccessResponse = commonReducerResponse.bookkeeperModuleAccess
    const checkLogsExistsResponse = commonReducerResponse.checkLogsExists
    const enableWitnessCarry = witnessCarryResponse?.data;
    const checkLogsExistsData = checkLogsExistsResponse?.data;

    return {
        updateLabelToMarginResponse,
        updateLabelPrintHeaderResponse,
        updateLabelHeaderTopMarginResponse,
        updateLabelPrintTypeResponse,
        updateLabelPrintLogoResponse,
        updateLabelLeftMarginResponse,
        updateLabelSigGapResponse,
        pharmacyGetConsentEmailDataResponse,
        pharmacyAddConsentEmailDataResponse,
        pharmacyUpdateAuthenticationPhoneNumberResponse,
        pharmacyGetAuthenticationPhoneNumberResponse,
        getSearchHistoryResponse,
        storeSearchHistoryResponse,
        witnessCarryResponse,
        bookkeeperModuleAccessResponse,
        checkLogsExistsResponse,
        enableWitnessCarry,
        checkLogsExistsData
    }
}

export const selectWitnessCarry = (state) => state.commonReducerForInitalData.witnessCarry;
